import { useContext, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useAuth } from "react-oidc-context";
import { AccountContext } from "@/context/account";
import { MeContext } from "@/context/me/MeContext";
import {
  isActiveSupportModeForAccount,
  useSupportMode,
} from "@/context/supportMode";
import { identifyBrowserSession } from "./session";

/** JWT `sub` is the signed-in user; role/account attach later when those contexts exist. */
export function NewRelicSession() {
  const { user } = useAuth();
  const userId = user?.profile.sub;
  const me = useContext(MeContext)?.me;
  const account = useContext(AccountContext)?.account;
  const { session } = useSupportMode();
  const { i18n } = useTranslation();

  useEffect(() => {
    if (userId === undefined || userId.length === 0) {
      return;
    }

    identifyBrowserSession({
      userId,
      userRole: me?.role ?? undefined,
      accountId: account?.id,
      locale: i18n.resolvedLanguage ?? i18n.language,
      supportMode: isActiveSupportModeForAccount(session, account?.id),
    });
  }, [
    account?.id,
    i18n.language,
    i18n.resolvedLanguage,
    me?.role,
    session,
    userId,
  ]);

  return null;
}
